export type TaxNumber = string | number

export const TAX_NUMBER_POSSIBLE_LENGTHS_RU = [10, 12]

export function checkTaxNumberDigits(taxNumber: string, coefficients: number[]): number {
  let n = 0

  coefficients.forEach((value, index) => {
    n += value * Number(taxNumber[index])
  })

  return parseInt(`${(n % 11) % 10}`, 10)
}

export function checkTaxNumberNotEmpty(taxNumber: string): boolean {
  return taxNumber.length > 0
}

export function checkTaxNumberDigitsOnly(taxNumber: string): boolean {
  return !/[^0-9]/.test(taxNumber)
}

export function checkTaxNumberLength(taxNumber: string, possibleLengths: number[]): boolean {
  return possibleLengths.indexOf(taxNumber.length) !== -1
}

export function checkTaxNumberRu10(taxNumber: string): boolean {
  // Дополнительная проверка если используется отдельно
  if (taxNumber.length !== 10) return false

  const n10 = checkTaxNumberDigits(taxNumber, [2, 4, 10, 3, 5, 9, 4, 6, 8])

  return n10 === parseInt(taxNumber[9], 10)
}

export function checkTaxNumberRu12(taxNumber: string): boolean {
  // Дополнительная проверка если используется отдельно
  if (taxNumber.length !== 12) return false

  const n11 = checkTaxNumberDigits(taxNumber, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8])
  const n12 = checkTaxNumberDigits(taxNumber, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8])

  return n11 === parseInt(taxNumber[10], 10) && n12 === parseInt(taxNumber[11], 10)
}

export function checkTaxNumberRu(taxNumber: string): boolean {
  switch (taxNumber.length) {
    case 10:
      return checkTaxNumberRu10(taxNumber)
    case 12:
      return checkTaxNumberRu12(taxNumber)
    default:
      return false
  }
}

export function validateTaxNumberRu(taxNumber: TaxNumber): boolean {
  const taxNumberString = `${taxNumber}`

  if (!checkTaxNumberNotEmpty(taxNumberString)) return false

  if (!checkTaxNumberDigitsOnly(taxNumberString)) return false

  if (!checkTaxNumberLength(taxNumberString, TAX_NUMBER_POSSIBLE_LENGTHS_RU)) return false

  return checkTaxNumberRu(taxNumberString)
}
